import { render } from "./FilterAccordionItem.vue?vue&type=template&id=78dc0aa2&scoped=true"
import script from "./FilterAccordionItem.vue?vue&type=script&lang=ts"
export * from "./FilterAccordionItem.vue?vue&type=script&lang=ts"

import "./FilterAccordionItem.vue?vue&type=style&index=0&id=78dc0aa2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78dc0aa2"

export default script